import {
  createClient,
  type Session,
  type SupabaseClient,
} from "@supabase/supabase-js";
import { getWorkspaceKey } from "./coach-workspace-key";

let clientPromise: Promise<SupabaseClient> | undefined;

export function getCoachAuthClient() {
  if (!clientPromise)
    clientPromise = fetch("/api/coach-auth-config")
      .then(async (response) => {
        if (!response.ok) throw new Error("Coach accounts are not configured");
        return (await response.json()) as {
          url: string;
          publishableKey: string;
        };
      })
      .then(({ url, publishableKey }) =>
        createClient(url, publishableKey, {
          auth: {
            flowType: "pkce",
            persistSession: true,
            autoRefreshToken: true,
            detectSessionInUrl: true,
          },
        }),
      );
  return clientPromise;
}

export async function getCoachSession(): Promise<Session | null> {
  try {
    const client = await getCoachAuthClient();
    const { data } = await client.auth.getSession();
    return data.session;
  } catch {
    return null;
  }
}

export async function sendCoachMagicLink(email: string) {
  const client = await getCoachAuthClient();
  return client.auth.signInWithOtp({
    email,
    options: { emailRedirectTo: `${window.location.origin}/drills` },
  });
}

export async function migrateRecoveryWorkspace(session: Session) {
  const marker = `puckly-coach-migrated-${session.user.id}`;
  if (localStorage.getItem(marker)) return true;
  const response = await fetch("/api/coach-workspace-migrate", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${session.access_token}`,
      "X-Coach-Workspace-Key": getWorkspaceKey(),
    },
  });
  if (!response.ok) return false;
  localStorage.setItem(marker, "true");
  return true;
}
